import angular from 'angular'

import { isPromise } from '../../utils/bits'
import { assign, stubTrue } from 'lodash-es'

import browser from '../../utils/browser'

angular
  .module('ggs.gallery-embed')
  .factory('EmbedStateMachine', EmbedStateMachineProvider)

function EmbedStateMachineProvider(qh, $log) {
  const SHOW_THUMB = '0 - SHOW_THUMB: thumb-show spinner-hide embed-dsbl retry-hide'
  const DBNC_EMBED = '1 - DBNC_EMBED: thumb-show spinner-show embed-dsbl retry-hide'
  const INIT_EMBED = '2 - INIT_EMBED: thumb-show spinner-show embed-hide retry-hide'
  const SHOW_RETRY = '3 - SHOW_RETRY: thumb-hide spinner-hide embed-dsbl retry-show'
  const PLAY_EMBED = '4 - PLAY_EMBED: thumb-show spinner-show embed-hide retry-hide'
  const SHOW_EMBED = '5 - SHOW_EMBED: thumb-hide spinner-hide embed-show retry-hide'
  const PEND_EMBED = '6 - PEND_EMBED: thumb-hide spinner-hide embed-show retry-hide html-player-pend'
  const UNPD_EMBED = '7 - UNPD_EMBED: thumb-hide spinner-hide embed-show retry-hide html-player-unpd'
  const HIDE_EMBED = '8 - HIDE_EMBED: thumb-hide spinner-hide embed-show retry-hide'

  const STATE_TO_FLAGS = {
    [SHOW_THUMB]: {
      showsThumb: true,
      showsSpinner: false,
      initsPlayer: false,
      showsPlayer: false,
      showsRetry: false
    },
    [DBNC_EMBED]: {
      showsThumb: true,
      showsSpinner: true,
      initsPlayer: false,
      showsPlayer: false,
      showsRetry: false
    },
    [INIT_EMBED]: {
      showsThumb: true,
      showsSpinner: true,
      initsPlayer: true,
      showsPlayer: false,
      showsRetry: false
    },
    [SHOW_RETRY]: {
      showsThumb: true,
      showsSpinner: false,
      initsPlayer: false,
      showsPlayer: false,
      showsRetry: true
    },
    [PLAY_EMBED]: {
      showsThumb: true,
      showsSpinner: true,
      initsPlayer: true,
      showsPlayer: false,
      showsRetry: false
    },
    [SHOW_EMBED]: {
      showsThumb: false,
      showsSpinner: false,
      initsPlayer: true,
      showsPlayer: true,
      showsRetry: false
    },
    [PEND_EMBED]: {
      showsThumb: false,
      showsSpinner: false,
      initsPlayer: true,
      showsPlayer: true,
      showsRetry: false
    },
    [UNPD_EMBED]: {
      showsThumb: false,
      showsSpinner: false,
      initsPlayer: true,
      showsPlayer: true,
      showsRetry: false
    },
    [HIDE_EMBED]: {
      showsThumb: false,
      showsSpinner: false,
      initsPlayer: true,
      showsPlayer: true,
      showsRetry: false
    }
  }

  const STATE_MACHINE = {
    [SHOW_THUMB]: {
      flags: STATE_TO_FLAGS[SHOW_THUMB],
      apply: (it) => {
        it.htmlPlayer = null
        it.embedStatus = null
      },
      rules: [{
        state: INIT_EMBED,
        test: (it) => (it.thumbStatus === it.FAIL || it.thumbStatus === it.DONE) && it.isActionAllowed && (it.isDisplayed && it.isInViewport)
      }, {
        state: DBNC_EMBED,
        test: (it) => (it.thumbStatus === it.FAIL || it.thumbStatus === it.DONE) && it.isActionDebouncing && (it.isDisplayed && it.isInViewport)
      }]
    },
    [DBNC_EMBED]: {
      flags: STATE_TO_FLAGS[DBNC_EMBED],
      rules: [{
        state: SHOW_THUMB,
        test: (it) => (!it.isActionAllowed && !it.isActionDebouncing) || (!it.isDisplayed || !it.isInViewport)
      }, {
        state: INIT_EMBED,
        test: (it) => it.isActionAllowed
      }]
    },
    [INIT_EMBED]: {
      flags: STATE_TO_FLAGS[INIT_EMBED],
      rules: [{
        state: SHOW_THUMB,
        test: (it) => !it.isActionAllowed || (!it.isDisplayed || !it.isInViewport)
      }, {
        state: SHOW_RETRY,
        test: (it) => it.embedStatus === it.FAIL
      }, {
        state: PLAY_EMBED,
        test: (it) => it.embedStatus === it.DONE
      }]
    },
    [SHOW_RETRY]: {
      flags: STATE_TO_FLAGS[SHOW_RETRY],
      rules: [{
        state: SHOW_THUMB,
        test: (it) => (it.embedStatus === it.REDO) || !it.isActionAllowed || (!it.isDisplayed || !it.isInViewport)
      }]
    },
    [PLAY_EMBED]: {
      flags: STATE_TO_FLAGS[PLAY_EMBED],
      apply: (it) => {
        const shouldTry = !it.useIframe && browser.likeDesktop
        return shouldTry ? qh.attempt(it.htmlPlayer.autoplay) : qh.delay(200)
      },
      rules: [{
        state: SHOW_THUMB,
        test: (it) => !it.isActionAllowed || (!it.isDisplayed || !it.isInViewport)
      }, {
        state: SHOW_EMBED,
        test: stubTrue
      }]
    },
    [SHOW_EMBED]: {
      flags: STATE_TO_FLAGS[SHOW_EMBED],
      apply: (it) => it.ggsEmbedLoadHandler(),
      rules: [{
        state: HIDE_EMBED,
        test: (it) => !it.isActionAllowed || ((!it.isDisplayed || !it.isInViewport) && it.useIframe)
      }, {
        state: PEND_EMBED,
        test: (it) => (!it.isDisplayed || !it.isInViewport) && !it.useIframe
      }]
    },
    [PEND_EMBED]: {
      flags: STATE_TO_FLAGS[PEND_EMBED],
      apply: (it) => qh.attempt(it.htmlPlayer.pause),
      rules: [{
        state: HIDE_EMBED,
        test: (it) => !it.isActionAllowed
      }, {
        state: UNPD_EMBED,
        test: (it) => it.isDisplayed && it.isInViewport
      }]
    },
    [UNPD_EMBED]: {
      flags: STATE_TO_FLAGS[UNPD_EMBED],
      apply: (it) => qh.attempt(it.htmlPlayer.play),
      rules: [{
        state: HIDE_EMBED,
        test: (it) => !it.isActionAllowed
      }, {
        state: PEND_EMBED,
        test: (it) => !it.isDisplayed || !it.isInViewport
      }]
    },
    [HIDE_EMBED]: {
      flags: STATE_TO_FLAGS[HIDE_EMBED],
      apply: (it) => it.ggsEmbedUnloadHandler(),
      rules: [{
        state: SHOW_THUMB,
        test: stubTrue
      }]
    }
  }

  return function createMachine(it) {
    it.state = SHOW_THUMB
    setup(it)
    return () => recalc(it)
  }

  function recalc(it) {
    let newState = null
    const props = STATE_MACHINE[it.state]
    const rules = props.rules
    for (let i = 0, l = rules.length; i !== l; i++) {
      const rule = rules[i]
      if (rule.test(it)) {
        newState = rule.state
        break
      }
    }

    if (newState) {
      it.state = newState
      return setup(it)
    }
  }

  function setup(it) {
    const sign = `GalleryEmbed::EmbedStateMachine[id=${it.ggsPost.id}]`
    $log.debug(`${sign}: init`, it.state)
    const props = STATE_MACHINE[it.state]
    assign(it, props.flags)
    const res = props.apply && props.apply(it)
    if (isPromise(res)) {
      return res
        .then(() => $log.debug(`${sign}: done`, it.state))
        .then(() => recalc(it))
    } else {
      $log.debug(`${sign}: done`, it.state)
      return recalc(it)
    }
  }
}
